import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireAuthContext from '../../authorization/requireAuthContext'
import EntityId = com.eidu.sharedlib.entity.EntityId

type DeleteEntityParameters = { id: EntityId }

const deleteEntity = async ({ id }: DeleteEntityParameters) => {
  const authContext = await requireAuthContext()
  const response = await fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${id.toString()}`,
    {
      headers: { Authorization: `Bearer ${authContext.accessToken}` },
      method: 'DELETE',
    }
  )
  if (response.status !== 200) throw Error(`Unexpected response code ${response.status} from deleteEntity endpoint`)
}

export default deleteEntity
